import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@rtkwlf/pro-solid-svg-icons/faExternalLinkAlt';

import { ListItemButton } from '../../../components/list';

import { MenuLinkContent } from './menu-link-content';
import type { MenuLinkExternalProps } from './menu-link-types';

export const MenuLinkExternal = ({
  icon,
  title,
  externalUrl,
  ...rest
}: MenuLinkExternalProps) => {
  const titleEndIcon = (
    <FontAwesomeIcon
      icon={faExternalLinkAlt}
      color="var(--aw-palette-text-disabled)"
      size="xs"
    />
  );

  return (
    <ListItemButton
      href={externalUrl}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      <MenuLinkContent icon={icon} title={title} titleEndIcon={titleEndIcon} />
    </ListItemButton>
  );
};
